import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import { toastError } from "../../Components/Toasts/Toast";
import { useForm, Controller } from "react-hook-form";
import { InputSwitch } from "primereact/inputswitch";
import ModalFormFeature from "../../Components/Product/Modal/ModalFormFeature";
import {
  getSkuAllHeader,
  getSubcategoryPrefix,
} from "../../Services/SkuService";
import { getSubcategoryAll } from "../../Services/SubcategoryService";
import { getSubSubcategoryAll } from "../../Services/SubSubcategoryService";
import { getCertAll } from "../../Services/CertService";
import { getCountryAll } from "../../Services/CountryService";
import { getColorAll } from "../../Services/ColorService";
import { getERatingAll } from "../../Services/ERatingService";
import { getAllAssembles } from "../../Services/AssemblyServices";
import { getPclAll } from "../../Services/PclService";
import { getSegmentAll } from "../../Services/SegmentService";
import { getCategoryAll } from "../../Services/CategoryService";
import { getBrandAll } from "../../Services/BrandService";
import { createProduct } from "../../Services/ProductService";
import { getLanguages } from "../../Services/LanguageService";
import {
  getAppList,
  getImageFunc,
  getVideoFunc,
} from "../../Services/AppService";
import { getProduct, getProductsAll } from "../../Services/ProductService";
import { getSeupplier } from "../../Services/SAPService";
import { getSeriesAll } from "../../Services/SeriesService";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import Overlay from "../../Components/Overlay/Overlay";
import Sku from "../../Components/Product/Sku";
import InputAutoComplete from "../../Components/Autocomplete/InputAutoComplete";
import bwipjs from "bwip-js";
import { getFeatureBySubCategory } from "../../Services/FeatureService";
import { handlerFormError } from "../../Utils/Utils";
import ProductDimension from "../../Components/Product/FileHandler/ProductDimension";
import { getIotSeriesAll } from "../../Services/IoTSeriesService";

const { $ } = window;
const modalId = "#product-create-modal";
let processingId = -1;
const modalId10 = "#product-create-feature-score";

//update gadanta
const ProductMasterPage = () => {
  const darkMode = useSelector((state) => state.theme.darkMode);
  let { userInfo } = useSelector((state) => state.auth);
  const { pageState, item_code } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    getValues,
    setError,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      id_segment: "1",
      id_category: "",
      id_sub_category: "",
      id_sub_sub_category: 0,
      id_series: 0,
      code_iot_series: "",
      prefix: "",
      id_brand: "",
      prefix: "",
      color: "",
      model_code: "",
      item_name: "",
      item_code_original: "",
      group_code: "",
      country_code: "",
      certificate: "",
      electrical_rating: "",
      assembly: "",
      part_change_sequence: "",
      part_change_location: "",
      unit: "",
      series: "",
      iot_series: "",
      height: 0,
      width: 0,
      length: 0,
      depth: 0,
      weight: 0,
      volume: 0,
      outer_height: 0,
      outer_width: 0,
      outer_length: 0,
      outer_depth: 0,
      outer_weight: 0,
      cut_out_height: 0,
      cut_out_width: 0,
      cut_out_length: 0,
      cut_out_depth: 0,
      cut_out_height_topmount: 0,
      cut_out_width_topmount: 0,
      cut_out_length_topmount: 0,
      cut_out_height_undermount: 0,
      cut_out_width_undermount: 0,
      cut_out_length_undermount: 0,
      weight_type: "",
      scale: "",
      launch_date: "",
      cardcode: "",
      barcode_sni: "",
      barcode_qr: "",
      is_active: true,
      is_publish_web: false,
      is_manage_serial: false,
      numRows: 1,
      numRowsUps: 1,
      product_class: "",
    },
  });

  const [skuTemp, setSkuTemp] = useState({
    3: "",
    4: "",
    5: "",
    6: "",
    7: "",
    8: "",
  });

  const [state, setState] = useState({
    countryChange: null,
    products: [],
    suppliers: [],
    selectedItemCode: "",
    selectedSupplierCode: "",
    segments: [],
    categories: [],
    subcategories: [],
    subsubcategories: [],
    pseries: [],
    iotseries: [],
    id_sub_sub_category: 0,
    id_series: 0,
    code_iot_series: "",
    showIotSeries: false,
    colors: [],
    countries: [],
    certs: [],
    eratings: [],
    assembles: [],
    pcls: [],
    brands: [],
    subprefixs: [],
    skuHeaders: [],
    sku: [],
    activeIndex: -1,
    firstPrefix: "",
    secondPrefix: "",
    firstColor: "",
    secondColor: "",
    firstCountry: "",
    secondCountry: "",
    cert: "",
    erating: "",
    assembly: "",
    partSequence: "",
    pcl: "",
    files: [],
    manualBooks: [],
    filesDescs: [],
    videoDescs: [],
    fileSelected: {
      fileName: "",
      media_desc: "",
      media_types: [],
      content_types: [],
    },
    videoSelected: "",
    brandPrefix: "",
    media_types: [],
    video_types: [],
    content_types: [],
    is_active: true,
    is_publish_web: false,
    is_manage_serial: false,
    languages: [],
    selectedLang: {
      language_code: "",
      language_name: "",
    },
    productDetails: [],
    productDetail: {
      language_code: "",
      language_name: "",
      title: "",
      header_description: "",
      description: "",
      feature: "",
      including: "",
      tagline: "",
      price: "",
      manual_book: "",
      is_preorder: 0,
      is_rental: 0,
      is_active: true,
      is_me_by_modena: 0,
      sku_me_by_modena: "",
      sticker_price: 0,
      seo_title: "",
      seo_description: "",
      url_ar: "",
    },
    productHighlights: [],
    productHighlight: [],
    deletedHighlight: [],
    deletedEcom: [],
    filesNew: [],
    filesDescsNew: [],
    fileSelectedNew: {
      fileName: "",
      media_desc: "",
      media_types: [],
      content_types: [],
    },
    productUps: [
      // {
      //   "id": null,
      //   "name": "",
      //   "media_code": "",
      //   "media_type": [],
      //   "media_desc": "",
      //   "content_type": [],
      //   "file_path": "",
      //   "tags": []
      // },
    ],
    filesUps: [],
    filesDescsUpss: [],
    filesDescsUps: [],
    fileSelectedUps: {
      fileNameUps: "",
      media_desc: "",
      language_code: "",
      line_num: "",
      media_types: [],
      content_types: [],
    },
    productEcom: [],
    deleteEcom: [],
    feature_type: [],
    reqFeature: [],
    totScoreFeature: 0,
    processing: false,
    videoUrl: "",
    videoLang: "",
    numRows: 1,
    numRowsUps: 1,
    show: false,
    activeTab: "tab1",
    sub_sub_category: {},
  });

  const genBarcode = (e, value) => {
    try {
      bwipjs.toCanvas("barcode", {
        bcid: "code128",
        text: value ? value : e.target.value,
        scale: 2,
        height: 5,
        includetext: true,
        textxalign: "center",
      });
    } catch (e) {}
  };

  const genQRCode = (e, value) => {
    try {
      bwipjs.toCanvas("qrcode", {
        bcid: "qrcode",
        text: value ? value : e.target.value,
        scale: 3,
        height: 15,
        includetext: false,
        textxalign: "center",
      });
    } catch (e) {}
  };

  const onBack = () => {
    if (item_code) {
      navigate("/product");
    } else {
      navigate(-1);
    }
  };

  const onReset = () => {
    reset({
      id_segment: "",
      id_category: "",
      id_sub_category: "",
      id_sub_sub_category: 0,
      id_series: 0,
      code_iot_series: "",
      prefix: "",
      id_brand: "",
      prefix: "",
      color: "",
      model_code: "",
      item_name: "",
      item_code_original: "",
      group_code: "",
      country_code: "",
      certificate: "",
      electrical_rating: "",
      assembly: "",
      part_change_sequence: "",
      part_change_location: "",
      unit: "",
      series: "",
      iot_series: "",
      height: 0,
      width: 0,
      length: 0,
      depth: 0,
      weight: 0,
      volume: 0,
      outer_height: 0,
      outer_width: 0,
      outer_length: 0,
      outer_depth: 0,
      outer_weight: 0,
      cut_out_height: 0,
      cut_out_width: 0,
      cut_out_length: 0,
      cut_out_depth: 0,
      cut_out_height_topmount: 0,
      cut_out_width_topmount: 0,
      cut_out_length_topmount: 0,
      cut_out_height_undermount: 0,
      cut_out_width_undermount: 0,
      cut_out_length_undermount: 0,
      weight_type: "",
      scale: "",
      launch_date: "",
      cardcode: "",
      barcode_sni: "",
      barcode_qr: "",
      is_active: true,
      is_manage_serial: false,
      is_publish_web: false,
      numRows: 1,
      show: false,
      activeTab: "tab1",
      fileSelectedNew: {
        fileName: "",
        media_desc: "",
        media_types: [],
        content_types: [],
      },
      productHighlights: [],
      deletedHighlight: [],
      productHighlight: [
        {
          language_code: "",
          language_name: "",
          title: "",
          description: "",
        },
      ],
      productUps: [
        //   {
        //   "id": null,
        //   "name": "",
        //   "media_code": "",
        //   "media_type": [],
        //   "media_desc": "",
        //   "content_type": [],
        //   "file_path": "",
        //   "tags": []
        // },
      ],
      filesUps: [],
      filesDescsUpss: [],
      filesDescsUps: [],
      productEcom: [],
      deleteEcom: [],
      fileSelectedUps: {
        fileNameUps: "",
        media_desc: "",
        language_code: "",
        line_num: "",
        media_types: [],
        content_types: [],
      },
      numRowsUps: 1,
      feature_type: [],
      reqFeature: [],
      totScoreFeature: 0,
      product_class: "",
    });

    setState({
      ...state,
      selectedItemCode: "",
      selectedSupplierCode: "",
      skuHeaders: [],
      suppliers: [],
      sku: [],
      activeIndex: -1,
      firstPrefix: "",
      secondPrefix: "",
      firstColor: "",
      secondColor: "",
      firstCountry: "",
      secondCountry: "",
      cert: "",
      erating: "",
      assembly: "",
      partSequence: "",
      pcl: "",
      files: [],
      manualBooks: [],
      filesDescs: [],
      videoDescs: [],
      fileSelected: {
        fileName: "",
        media_desc: "",
        media_types: [],
        content_types: [],
      },
      videoSelected: "",
      brandPrefix: "",
      is_active: true,
      is_manage_serial: false,
      is_publish_web: false,
      selectedLang: {
        language_code: "",
        language_name: "",
      },
      productDetails: [],
      productDetail: {
        language_code: "",
        language_name: "",
        title: "",
        header_description: "",
        description: "",
        feature: "",
        including: "",
        tagline: "",
        price: "",
        manual_book: "",
        is_preorder: 0,
        is_rental: 0,
        is_active: true,
        is_me_by_modena: 0,
        sku_me_by_modena: "",
        sticker_price: 0,
        seo_title: "",
        seo_description: "",
        url_ar: "",
      },
      fileSelectedNew: {
        fileName: "",
        media_desc: "",
        media_types: [],
        content_types: [],
      },
      productHighlights: [],
      deletedHighlight: [],
      deletedEcom: [],
      productHighlight: [
        {
          language_code: "",
          language_name: "",
          title: "",
          description: "",
        },
      ],
      // productUps: [{
      //   "id": null,
      //   "name": "",
      //   "media_code": "",
      //   "media_type": [],
      //   "media_desc": "",
      //   "content_type": [],
      //   "file_path": "",
      //   "tags": []
      // },],
      filesUps: [],
      filesDescsUps: [],
      filesDescsUpss: [],
      fileSelectedUps: {
        fileNameUps: "",
        media_desc: "",
        language_code: "",
        line_num: "",
        media_types: [],
        content_types: [],
      },
      productEcom: [],
      deleteEcom: [],
      feature_type: [],
      reqFeature: [],
      totScoreFeature: 0,
      numRows: 1,
      numRowsUps: 1,
      show: false,
      activeTab: "tab1",
    });
  };

  const onCopyItemCode = (item_code) => {
    navigate(`/product/copy/${item_code}`);
  };

  const onAddFeatureModal = (a) => {
    setTimeout(() => {
      $(modalId10).modal("show");
    }, 150);
  };

  const onSetItemCode = (e) => {
    setState({ ...state, selectedItemCode: e.target.value });
  };

  const onSetSupplierCode = (e) => {
    setState({ ...state, selectedSupplierCode: e.target.value });
  };

  const onClickSupplier = (value) => {
    setValue("cardcode", value);
    setState({ ...state, suppliers: [], selectedItemCode: value });
  };

  const startProcessing = () => {
    processingId = setTimeout(() => {
      setState({ ...state, processing: true });
    }, 150);
  };

  const stopProcessing = () => {
    clearTimeout(processingId);
    setState({ ...state, processing: false });
  };

  const onAddDigit = (digit) => {
    if (skuHeaders && skuHeaders.length > 0) {
      const index = skuHeaders.findIndex((e) => e.sku_index == digit);
      setState({ ...state, activeIndex: index });
    } else {
      toastError("Subcategory prefix is empty, please choose one!");
    }
  };

  const onFileChange = (e) => {
    const _files = [...files, ...e.target.files];
    setState({ ...state, files: _files });
  };

  const onRemoveFile = (i) => () => {
    files.splice(i, 1);
    setState({ ...state, files });
  };

  const onRemoveVideo = (i) => () => {
    videoDescs.splice(i, 1);
    setState({ ...state, videoDescs });
  };

  const setChange = (e) => {
    if (e.target.name === "prefix") {
      if (e.target.value != "") {
        const prefix = e.target.value;
        const index = subprefixs.findIndex((e) => e.header_code == prefix);

        setValue("id_segment", subprefixs[index].id_segment);
        setValue("id_category", subprefixs[index].id_category);
        setValue("id_sub_category", subprefixs[index].id_sub_category);
        setValue("product_class", "");

        // getSubcategoryPrefix(subprefixs[index].id_sub_category, prefix, ({ data }) => {
        //   setState({ ...state, skuHeaders: data.sku_headers, subsubcategories: data.subsubcategories, sku: [], activeIndex: -1, firstPrefix: prefix.charAt(0), secondPrefix: prefix.charAt(1) });
        // });

        const results = [
          getSubcategoryPrefix(subprefixs[index].id_sub_category, prefix).then(
            (res) => res.data
          ),
          getSeriesAll({
            filter: `id_segment:${subprefixs[index].id_segment}`,
          }).then((res) => res.data.data),
          //getFeatureBySubCategory(subprefixs[index].id_sub_category).then(res => res.data)
        ];

        Promise.all(results).then((results) => {
          const [_sscategory, _series] = results;
          setState({
            ...state,
            pseries: _series,
            reqFeature: [],
            totScoreFeature: 0,
            skuHeaders: _sscategory.sku_headers,
            subsubcategories: _sscategory.subsubcategories,
            sku: [],
            activeIndex: -1,
            firstPrefix: prefix.charAt(0),
            secondPrefix: prefix.charAt(1),
          });
        });

        setValue("subsubcategories", subsubcategories);
      } else {
        setValue("id_segment", "");
        setValue("id_category", "");
        setValue("id_sub_category", "");
        setValue("product_class", "");
        setState({
          ...state,
          reqFeature: [],
          feature_type: [],
          skuHeaders: [],
          pseries: [],
          totScoreFeature: 0,
          subsubcategories: [],
          activeIndex: -1,
          firstPrefix: "",
          secondPrefix: "",
        });
        setValue("subsubcategories", []);
        setValue("pseries", []);
      }
    }
  };

  const setSku = (e, digit) => {
    let _sku = { ...skuTemp };
    let _sku_array = undefined;
    if (sku) {
      _sku_array = JSON.parse(JSON.stringify(sku));
      for (let i = 0; i < _sku_array.length; i++) {
        _sku[i] = _sku_array[i];
      }
    }
    _sku[digit] = e.target.value;
    _sku_array[digit] = e.target.value;
    setSkuTemp(_sku);
    setState({ ...state, sku: _sku_array });
    //setTimeout(() => {
    genModelCode(firstColor, secondColor, _sku);
    //}, 150);
  };

  const setColor = (e) => {
    const color = e.target.value;
    setState({
      ...state,
      firstColor: color.charAt(0),
      secondColor: color.charAt(1),
    });
    setTimeout(() => {
      genModelCode(color.charAt(0), color.charAt(1), skuTemp);
    }, 150);
  };

  const setCountry = (e) => {
    const country = e.target.value.toUpperCase();
    setState({
      ...state,
      firstCountry: country.charAt(0),
      secondCountry: country.charAt(1),
      countryChange: e.target.value,
    });
  };

  const setCert = (e) => {
    setState({ ...state, cert: e.target.value.toUpperCase() });
  };

  const setERating = (e) => {
    setState({ ...state, erating: e.target.value.toUpperCase() });
  };

  const setAssembly = (e) => {
    setState({
      ...state,
      assembly: e.target.value.split("-")[0].toUpperCase(),
    });
  };

  const setPartSequence = (e) => {
    setState({ ...state, partSequence: e.target.value.toUpperCase() });
  };

  const setPartLocation = (e) => {
    setState({ ...state, pcl: e.target.value.toUpperCase() });
  };

  const onBrandChange = (e) => {
    setState({ ...state, brandPrefix: e.target.value.split("-")[1] });
  };

  const onSubSubChange = (e) => {
    const _sub_sub_category = subsubcategories.find(
      (item) => item.id == e.target.value
    );

    getFeatureBySubCategory(
      _sub_sub_category ? _sub_sub_category.id : 0,
      ({ data }) => {
        setState((state) => {
          return {
            ...state,
            id_sub_sub_category: e.target.value,
            sub_sub_category: _sub_sub_category,
            reqFeature: data,
            totScoreFeature: 0,
          };
        });
        setTimeout(() => {
          setValue("product_class", "");
        }, 100);
      },
      (error) => {}
    );
  };

  const onSerieshange = (e) => {
    setState({ ...state, id_series: e.target.value });
  };

  const onIotSerieshange = (e) => {
    setState({ ...state, code_iot_series: e.target.value });
  };

  const onAddFileDesc = (file) => {
    setState({ ...state, fileSelected: {} });
    const fileName = file.name.split(" ").join("");
    if (filesDescs[fileName]) {
      setState({ ...state, fileSelected: filesDescs[fileName] });
    } else {
      filesDescs[fileName] = {
        fileName,
        media_desc: "",
        media_types: [],
        content_types: [],
      };
      setState({ ...state, filesDescs, fileSelected: filesDescs[fileName] });
    }

    setTimeout(() => {
      $(modalId).modal("show");
    }, 150);
  };

  const onDescChange = (e) => {
    filesDescs[fileSelected.fileName].media_desc = e.target.value;
    const _fileSelected = { ...fileSelected, media_desc: e.target.value };
    setState({ ...state, filesDescs, fileSelected: _fileSelected });
  };

  const onAddFileDescModal = (type, position) => {
    const index =
      position == "media_types"
        ? filesDescs[fileSelected.fileName].media_types.indexOf(type)
        : filesDescs[fileSelected.fileName].content_types.indexOf(type);

    if (index > -1) {
      position == "media_types"
        ? filesDescs[fileSelected.fileName].media_types.splice(index, 1)
        : filesDescs[fileSelected.fileName].content_types.splice(index, 1);
    } else {
      position == "media_types"
        ? filesDescs[fileSelected.fileName].media_types.push(type)
        : filesDescs[fileSelected.fileName].content_types.push(type);
    }

    setState({ ...state, filesDescs });
  };

  const genModelCode = (setFirstColor, setSecondColor, skuMade = null) => {
    const modelCode = `${firstPrefix}${secondPrefix} ${skuMade[3] || ""}${
      skuMade[4] || ""
    }${skuMade[5] || ""}${skuMade[6] || ""} ${skuMade[7] || ""}${
      skuMade[8] || ""
    }${setFirstColor || ""}${setSecondColor || ""}`;
    setValue("model_code", modelCode);
  };

  const onSubmit = (data) => {
    if (sku.filter((e) => e && e != "").length != 6) {
      toastError("SKU length is not valid!");
      return;
    }

    if (data.length == 0 && data.depth == 0) {
      setError("length", { type: "min", message: "must be > 0" });
      setError("depth", { type: "min", message: "must be > 0" });
      return;
    } else {
      clearErrors(["length", "depth"]);
    }

    if (data.outer_length == 0 && data.outer_depth == 0) {
      setError("outer_length", { type: "min", message: "must be > 0" });
      setError("outer_depth", { type: "min", message: "must be > 0" });
      return;
    } else {
      clearErrors(["outer_length", "outer_depth"]);
    }

    if (data.is_manage_serial && data.barcode_qr == "") {
      setError("barcode_qr", {
        type: "required",
        message: "Serial Number is required!",
      });
      return;
    } else {
      clearErrors("barcode_qr");
    }

    if (data.launch_date && data.launch_date == "") {
      setError("launch_date", {
        type: "required",
        message: "Launch Date is required!",
      });
      return;
    } else {
      clearErrors("launch_date");
    }

    if (parseFloat(data.length) > 0 && parseFloat(data.depth) > 0) {
      toastError("Please set value to 0 for Length or Depth");
      return;
    }

    let newSecondColor = secondColor;
    if (showIotSeries && data.code_iot_series != "") {
      newSecondColor = data.code_iot_series;
    }

    const skuNumber =
      firstPrefix +
      secondPrefix +
      sku[3] +
      sku[4] +
      sku[5] +
      sku[6] +
      sku[7] +
      sku[8] +
      firstColor +
      newSecondColor +
      "." +
      firstCountry +
      secondCountry +
      cert +
      erating +
      assembly +
      partSequence +
      pcl;

    const formData = new FormData();

    formData.append("item_code", skuNumber);

    for (var key in data) {
      if (key == "id_brand") {
        formData.append(key, data[key].split("-")[0]);
      } else if (key == "assembly") {
        formData.append(key, data[key].split("-")[1]);
      } else {
        formData.append(key, data[key]);
      }
    }

    let m_image_errors = 0;
    let c_image_errors = 0;
    for (let f in filesDescs) {
      formData.append(`filesDescs[${f}][fileName]`, filesDescs[f].fileName);
      formData.append(`filesDescs[${f}][media_desc]`, filesDescs[f].media_desc);
      formData.append(
        `filesDescs[${f}][media_type]`,
        filesDescs[f].media_types
      );
      formData.append(
        `filesDescs[${f}][content_type]`,
        filesDescs[f].content_types
      );

      if (filesDescs[f].media_types.length == 0) {
        m_image_errors++;
      }

      if (filesDescs[f].content_types == 0) {
        c_image_errors++;
      }
    }

    if (filesNew.length > 0) {
      if (Object.keys(filesDescsNew).length > 0) {
        for (let n in filesDescsNew) {
          formData.append(
            `filesDescsNew[${n}][fileName]`,
            filesDescsNew[n].fileName
          );
          formData.append(
            `filesDescsNew[${n}][media_desc]`,
            filesDescsNew[n].media_desc
          );
          formData.append(
            `filesDescsNew[${n}][media_type]`,
            filesDescsNew[n].media_types
          );
          formData.append(
            `filesDescsNew[${n}][content_type]`,
            filesDescsNew[n].content_types
          );
          if (filesDescsNew[n].fileName != "") {
            if (filesDescsNew[n].media_types.length == 0) {
              m_image_errors++;
            }

            if (filesDescsNew[n].content_types == 0) {
              c_image_errors++;
            }
          }
        }
      } else {
        toastError(
          "Please fill description image product highlight before submit!"
        );
        return;
      }
    }

    // for (let oo in filesDescsUps) {
    //   formData.append(`filesDescsUps[${oo}][fileName]`, filesDescsUps[oo].fileNameUps);
    //   formData.append(`filesDescsUps[${oo}][media_desc]`, filesDescsUps[oo].media_desc);
    //   formData.append(`filesDescsUps[${oo}][media_type]`, filesDescsUps[oo].media_types);
    //   formData.append(`filesDescsUps[${oo}][content_type]`, filesDescsUps[oo].content_types);

    //   if (filesDescsUps[oo].fileNameUps != '') {

    //     if (filesDescsUps[oo].media_types.length == 0) {
    //       m_image_errors++;
    //     }

    //     if (filesDescsUps[oo].content_types == 0) {
    //       c_image_errors++;
    //     }
    //   }
    // }

    for (let ii in productUps) {
      if (filesUps.length > 0) {
        if (productUps[ii].media_type.length == 0) {
          m_image_errors++;
        }

        if (productUps[ii].content_type.length == 0) {
          c_image_errors++;
        }
      }
    }

    if (m_image_errors > 0) {
      toastError("Please complete all image functionality!");
      return;
    }

    if (c_image_errors > 0) {
      toastError("Please complete app name that using the image!");
      return;
    }

    for (let i in files) {
      formData.append(`images[${i}]`, files[i]);
    }

    for (let i in filesNew) {
      formData.append(`imagesHighlight[${i}]`, filesNew[i]);
    }

    for (let j in filesUps) {
      formData.append(`imagesUsp[${j}]`, filesUps[j]);
    }

    let xx = 0;
    for (let pd in productDetails) {
      if (
        productDetails[xx].title == "" ||
        productDetails[xx].description == "" ||
        productDetails[xx].header_description == "" ||
        productDetails[xx].tagline == "" ||
        productDetails[xx].id_color == "" ||
        productDetails[xx].id_tag == ""
      ) {
        toastError("Please save product detail before submit!");
        return;
      }
      xx++;
    }

    for (const key in productHighlights) {
      if (
        productHighlights[key].title == "" ||
        productHighlights[key].description == ""
      ) {
        toastError(
          "Please fill title and description product highlight before submit!"
        );
        return;
      }
    }

    for (let yt in productUps) {
      let dataDescUps = productUps[yt];
      let dataTags = productUps[yt].tags;

      if (dataDescUps.file_path == "" && dataTags.length > 0) {
        toastError(
          "Please upload the image for product usp highlight before submit!"
        );
        return;
      }

      if (dataDescUps.file_path != "") {
        if (dataTags) {
          for (let ee in dataTags) {
            if (dataTags[ee].title == "" || dataTags[ee].description == "") {
              toastError(
                "Please fill title and description product usp highlight before submit!"
              );
              return;
            }
          }
        } else {
          toastError(
            "Please fill title and description product usp highlight before submit!"
          );
          return;
        }
      }
    }

    let i = 0;
    for (let pd in productDetails) {
      formData.append(
        `productDetails[${i}][language_code]`,
        productDetails[pd].language_code
      );
      formData.append(`productDetails[${i}][title]`, productDetails[pd].title);
      formData.append(
        `productDetails[${i}][header_description]`,
        productDetails[pd].header_description
      );
      formData.append(
        `productDetails[${i}][description]`,
        productDetails[pd].description
      );
      formData.append(
        `productDetails[${i}][feature]`,
        productDetails[pd].feature
      );
      formData.append(
        `productDetails[${i}][including]`,
        productDetails[pd].including
      );
      formData.append(
        `productDetails[${i}][tagline]`,
        productDetails[pd].tagline
      );
      formData.append(`productDetails[${i}][price]`, productDetails[pd].price);
      formData.append(
        `productDetails[${i}][id_color]`,
        productDetails[pd].id_color
      );
      formData.append(
        `productDetails[${i}][id_tag]`,
        productDetails[pd].id_tag
      );
      formData.append(
        `productDetails[${i}][manual_book]`,
        productDetails[pd].manual_book
      );
      formData.append(
        `productDetails[${i}][is_preorder]`,
        productDetails[pd].is_preorder ? 1 : 0
      );
      formData.append(
        `productDetails[${i}][is_rental]`,
        productDetails[pd].is_rental ? 1 : 0
      );
      formData.append(
        `productDetails[${i}][is_me_by_modena]`,
        productDetails[pd].is_me_by_modena ? 1 : 0
      );
      formData.append(
        `productDetails[${i}][sku_me_by_modena]`,
        productDetails[pd].sku_me_by_modena
      );
      formData.append(
        `productDetails[${i}][sticker_price]`,
        productDetails[pd].sticker_price
      );
      formData.append(
        `productDetails[${i}][is_active]`,
        productDetails[pd].is_active
      );
      formData.append(
        `productDetails[${i}][seo_title]`,
        productDetails[pd].seo_title
      );
      formData.append(
        `productDetails[${i}][seo_description]`,
        productDetails[pd].seo_description
      );
      formData.append(
        `productDetails[${i}][url_ar]`,
        productDetails[pd].url_ar
      );
      i++;
    }

    // let h = 0;
    // for (let pdh in productHighlights) {
    //   let dataHighlight = productHighlights[pdh].data
    //   for (let pdhD in dataHighlight) {
    //     for (let index in dataHighlight[pdhD]) {
    //       formData.append(`productHighlights[${h}][${index}]`, dataHighlight[pdhD][index]);
    //     }
    //     h++;
    //   }
    // }

    for (let ft in feature_type) {
      let dataFeature = feature_type[ft];
      if (feature_type[ft].score > 0) {
        for (let fD in dataFeature) {
          formData.append(`feature_type[${ft}][${fD}]`, feature_type[ft][fD]);
        }
      } else {
        toastError("Please fill all score feature type!");
        return;
      }
    }

    for (let pdh in productHighlights) {
      let dataHighlight = productHighlights[pdh];
      if (
        productHighlights[pdh].title != "" &&
        productHighlights[pdh].description != ""
      ) {
        for (let pdhD in dataHighlight) {
          formData.append(
            `productHighlights[${pdh}][${pdhD}]`,
            productHighlights[pdh][pdhD]
          );
        }
      }
    }

    for (let ii in productUps) {
      let dataDescUps = productUps[ii];
      let dataTags = productUps[ii].tags;
      if (
        productUps[ii].file_path != "" &&
        productUps[ii].file_path != undefined
      ) {
        for (let index in dataDescUps) {
          if (index != "tags") {
            formData.append(`productUps[${ii}][${index}]`, dataDescUps[index]);
          }
        }
        for (let ee in dataTags) {
          for (let tag in dataTags[ee]) {
            formData.append(
              `productUps[${ii}][tags][${ee}][${tag}]`,
              dataTags[ee][tag]
            );
          }
        }
      }
    }

    for (let eco in productEcom) {
      let dataEco = productEcom[eco];
      if (
        productEcom[eco].id_store != "" &&
        productEcom[eco].url != "" &&
        productEcom[eco].price != "" &&
        productEcom[eco].id_store != null &&
        productEcom[eco].url != null &&
        productEcom[eco].price != null
      ) {
        for (let ec in dataEco) {
          formData.append(`productEcom[${eco}][${ec}]`, productEcom[eco][ec]);
        }
      } else {
        toastError("Please fill all ecommerce data before submit!");
        return;
      }
    }

    for (let i in manualBooks) {
      formData.append(`manual_books[${i}]`, manualBooks[i][0]);
    }

    let c_video_errors = 0;
    for (let v in videoDescs) {
      formData.append(`videoDescs[${v}][file_path]`, videoDescs[v].filePath);
      formData.append(`videoDescs[${v}][file_name]`, videoDescs[v].fileName);
      formData.append(
        `videoDescs[${v}][language_code]`,
        videoDescs[v].language_code
      );
      formData.append(
        `videoDescs[${v}][media_type]`,
        videoDescs[v].media_types
      );
      formData.append(
        `videoDescs[${v}][content_type]`,
        videoDescs[v].content_types
      );

      if (videoDescs[v].content_types == 0) {
        c_video_errors++;
      }
    }

    if (c_video_errors > 0) {
      toastError("Please complete app name that using the video!");
      return;
    }

    formData.append("color_code", `${firstColor}${secondColor}`);

    const response = createProduct(formData);
    startProcessing();
    response
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          Swal.fire({
            icon: "success",
            title: "Save data success",
            text: "Data has been saved!",
          }).then((r) => onBack());
        }
      })
      .catch(({ response: { data } }) => {
        handlerFormError(data);
      })
      .finally((_) => stopProcessing());
  };

  const countDimension = (e) => {
    if (e.target.value != "" && !isNaN(e.target.value)) {
      let height =
        e.target.id == "height"
          ? parseFloat(e.target.value)
          : parseFloat(control._formValues.height);
      let width =
        e.target.id == "width"
          ? parseFloat(e.target.value)
          : parseFloat(control._formValues.width);
      let length = parseFloat(control._formValues.length);
      let depth = parseFloat(control._formValues.depth);

      if (e.target.id == "length" && (depth <= 0 || depth == "")) {
        length = parseFloat(e.target.value);
        setValue("length", length);
        if (length == 0) {
          setValue("outer_length", 0);
        }
      } else if (e.target.id == "length") {
        length = 0;
        setValue("length", 0);
        setValue("outer_length", 0);
      }

      if (e.target.id == "depth" && (length <= 0 || length == "")) {
        depth = parseFloat(e.target.value);
        setValue("depth", depth);
        if (depth == 0) {
          setValue("outer_depth", 0);
        }
      } else if (e.target.id == "depth") {
        depth = 0;
        setValue("depth", 0);
        setValue("outer_depth", 0);
      }

      if (e.target.id == "outer_length" && (length <= 0 || length == "")) {
        setValue("outer_length", 0);
      }

      if (e.target.id == "outer_depth" && (depth <= 0 || depth == "")) {
        setValue("outer_depth", 0);
      }

      if (height && width && length > 0) {
        setValue(
          "volume",
          ((length / 10) * (width / 10) * (height / 10)).toFixed(4)
        );
      } else if (height && width && depth > 0) {
        setValue(
          "volume",
          ((depth / 10) * (width / 10) * (depth / 10)).toFixed(4)
        );
      }
    } else {
      setValue(e.target.id, "");
    }
  };

  const {
    subcategories,
    pseries,
    iotseries,
    showIotSeries,
    subsubcategories,
    subprefixs,
    firstPrefix,
    secondPrefix,
    firstColor,
    secondColor,
    firstCountry,
    secondCountry,
    cert,
    erating,
    assembly,
    partSequence,
    pcl,
    skuHeaders,
    activeIndex,
    sku,
    colors,
    countries,
    certs,
    eratings,
    assembles,
    pcls,
    segments,
    categories,
    brands,
    files,
    brandPrefix,
    filesDescs,
    fileSelected,
    media_types,
    video_types,
    content_types,
    productDetails,
    processing,
    videoUrl,
    videoDescs,
    videoSelected,
    videoLang,
    languages,
    products,
    selectedItemCode,
    selectedSupplierCode,
    suppliers,
    countryChange,
    productDetail,
    manualBooks,
    filesNew,
    fileSelectedNew,
    filesDescsNew,
    productHighlights,
    deletedHighlight,
    productHighlight,
    filesUps,
    fileSelectedUps,
    filesDescsUps,
    filesDescsUpss,
    productUps,
    productEcom,
    deleteEcom,
    reqFeature,
    totScoreFeature,
    feature_type,
    sub_sub_category,
  } = state;

  const idSegment = watch("id_segment");

  useEffect(() => {
    const _sku = JSON.parse(JSON.stringify(sku));
    if (_sku && _sku.length > 0) {
      if (_sku[7] == "I" && _sku[8] == "T") {
        setState({ ...state, showIotSeries: true, code_iot_series: "" });
      } else {
        setState({ ...state, showIotSeries: false, code_iot_series: "" });
      }
    } else {
      setState({ ...state, showIotSeries: false, code_iot_series: "" });
    }
  }, [sku, idSegment]);

  useEffect(() => {
    const reqVideoType = getVideoFunc({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqMediaType = getImageFunc({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqContentType = getAppList({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqLanguage = getLanguages({
      orders: "language_name:asc",
      perpage: 1000,
    }).then((res) => res.data.data);
    const reqSegment = getSegmentAll({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqCategory = getCategoryAll({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqSubcategory = getSubcategoryAll({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqSkuHeader = getSkuAllHeader({ perpage: 1000 }).then(
      (res) => res.data
    );
    const reqBand = getBrandAll({ perpage: 1000 }).then((res) => res.data.data);
    const reqColor = getColorAll({ orders: "name:asc", perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqCountry = getCountryAll({
      orders: "country_name:asc",
      perpage: 1000,
    }).then((res) => res.data.data);
    const reqCert = getCertAll({ perpage: 1000 }).then((res) => res.data.data);
    const reqERating = getERatingAll({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqAssembly = getAllAssembles({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqPcl = getPclAll({ perpage: 1000 }).then((res) => res.data.data);
    //const reqSubSubcategory = getSubSubcategoryAll({ perpage: 1000 }).then(
    // (res) => res.data.data
    //);
    const reqSeries = getSeriesAll({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqIotSeries = getIotSeriesAll({ perpage: 1000 }).then(
      (res) => res.data.data
    );

    switch (pageState) {
      case "add":
        Promise.all([
          reqVideoType,
          reqMediaType,
          reqContentType,
          reqLanguage,
          reqSegment,
          reqCategory,
          reqSubcategory,
          reqSkuHeader,
          reqColor,
          reqCountry,
          reqCert,
          reqERating,
          reqAssembly,
          reqBand,
          reqPcl,
          //reqSubSubcategory,
          reqSeries,
          reqIotSeries,
        ]).then((results) => {
          const [
            _video_types,
            _media_types,
            _content_types,
            _languages,
            _segments,
            _categories,
            _subcategories,
            _skuheaders,
            _colors,
            _countries,
            _certs,
            _eratings,
            _assembles,
            _brands,
            _pcls,
            //_subsubcategories,
            _pseries,
            _iotseries,
          ] = results;
          if (segments.length == 0) {
            setState({
              ...state,
              languages: _languages,
              segments: _segments,
              categories: _categories,
              subcategories: _subcategories,
              //subsubcategories: _subsubcategories,
              pseries: _pseries,
              iotseries: _iotseries,
              subprefixs: _skuheaders,
              colors: _colors,
              countries: _countries,
              certs: _certs,
              eratings: _eratings,
              assembles: _assembles,
              pcls: _pcls,
              brands: _brands,
            });
          } else {
            onReset();
          }
        });
        break;
      case "copy":
        const reqProduct = getProduct(item_code, "master").then(
          (res) => res.data
        );
        Promise.all([
          reqProduct,
          reqVideoType,
          reqMediaType,
          reqContentType,
          reqLanguage,
          reqSegment,
          reqCategory,
          reqSubcategory,
          reqSkuHeader,
          reqColor,
          reqCountry,
          reqCert,
          reqERating,
          reqAssembly,
          reqBand,
          reqPcl,
          reqSeries,
          reqIotSeries,
          //reqSubSubcategory,
        ]).then((results) => {
          const [
            _product,
            _video_types,
            _media_types,
            _content_types,
            _languages,
            _segments,
            _categories,
            _subcategories,
            _skuheaders,
            _colors,
            _countries,
            _certs,
            _eratings,
            _assembles,
            _brands,
            _pcls,
            _pseries,
            _iotseries,
            //_subsubcategories,
          ] = results;
          const _sku = [...sku];
          _sku[3] = _product.product.item_code_array[2];
          _sku[4] = _product.product.item_code_array[3];
          _sku[5] = _product.product.item_code_array[4];
          _sku[6] = _product.product.item_code_array[5];
          _sku[7] = _product.product.item_code_array[6];
          _sku[8] = _product.product.item_code_array[7];
          setState({
            ...state,
            countryChange: _product.product.country_code,
            languages: _languages,
            segments: _segments,
            categories: _categories,
            subcategories: _subcategories,
            //subsubcategories: _subsubcategories,
            subprefixs: _skuheaders,
            colors: _colors,
            countries: _countries,
            certs: _certs,
            eratings: _eratings,
            assembles: _assembles,
            pcls: _pcls,
            brands: _brands,
            selectedItemCode: item_code,
            skuHeaders: _product.product.sku_headers,
            productDetails: _product.productDetails,
            productHighlights: _product.productHighlights,
            brandPrefix: _product.product.id_brand_prefix.split("-")[1],
            firstPrefix: _product.product.item_code_array[0],
            secondPrefix: _product.product.item_code_array[1],
            firstColor: _product.product.item_code_array[8],
            secondColor: _product.product.item_code_array[9],
            firstCountry: _product.product.item_code_array[11],
            secondCountry: _product.product.item_code_array[12],
            cert: _product.product.item_code_array[13],
            erating: _product.product.item_code_array[14],
            assembly: _product.product.item_code_array[15],
            partSequence: _product.product.item_code_array[16],
            pcl: _product.product.item_code_array[17],
            sku: _sku,
            productEcom: _product.productEcom,
            pseries: _pseries,
            iotseries: _iotseries,
            product_class: _product.product.product_class,
          });

          setTimeout(() => {
            setValue("id_segment", _product.product.id_segment);
            setValue("id_category", _product.product.id_category);
            setValue("id_sub_category", _product.product.id_sub_category);
            setValue("item_name", _product.product.item_name);
            // setValue('id_sub_category', _product.product.id_sub_category);
            setValue("id_brand", _product.product.id_brand_prefix);
            setValue("assembly", _product.product.assembly);
            setValue("unit", _product.product.unit);
            setValue("is_active", _product.product.is_active);
            setValue("model_code", _product.product.model_code);
            setValue("group_code", _product.product.group_code);
            setValue("height", _product.product.height);
            setValue("width", _product.product.width);
            setValue("weight", _product.product.weight);
            setValue("weight_type", _product.product.weight_type);
            setValue("length", _product.product.length);
            setValue("depth", _product.product.depth);
            setValue("volume", _product.product.volume);
            setValue("thickness", _product.product.thickness);
            setValue("outer_height", _product.product.outer_height);
            setValue("outer_width", _product.product.outer_width);
            setValue("outer_weight", _product.product.outer_weight);
            setValue("outer_depth", _product.product.outer_depth);
            setValue("outer_length", _product.product.outer_length);
            setValue("cut_out_height", _product.product.cut_out_height);
            setValue("cut_out_width", _product.product.cut_out_width);
            setValue("cut_out_length", _product.product.cut_out_length);
            setValue("cut_out_depth", _product.product.cut_out_depth);
            setValue(
              "cut_out_height_topmount",
              _product.product.cut_out_height_topmount
            );
            setValue(
              "cut_out_width_topmount",
              _product.product.cut_out_width_topmount
            );
            setValue(
              "cut_out_length_topmount",
              _product.product.cut_out_length_topmount
            );
            setValue(
              "cut_out_height_undermount",
              _product.product.cut_out_height_undermount
            );
            setValue(
              "cut_out_width_undermount",
              _product.product.cut_out_width_undermount
            );
            setValue(
              "cut_out_length_undermount",
              _product.product.cut_out_length_undermount
            );
            setValue("color", _product.product.color_code);
            setValue("electrical_rating", _product.product.erating_code);
            setValue(
              "part_change_location",
              _product.product.parts_change_code
            );
            setValue("certificate", _product.product.certificate_code);
            setValue(
              "part_change_sequence",
              _product.product.part_change_sequence
            );
            setValue("country_code", _product.product.country_code);
            setValue("prefix", _product.product.prefix);
            setValue("barcode_sni", _product.product.barcode_sni);
            setValue("barcode_qr", _product.product.barcode_qr);
            setValue("launch_date", _product.product.launch_date);
            setValue("cardcode", _product.product.cardcode);
            setValue("scale", _product.product.scale);
            setValue("is_manage_serial", _product.product.is_manage_serial);
            setValue("is_publish_web", _product.product.is_publish_web);

            genBarcode(null, _product.product.barcode_sni);
            genQRCode(null, _product.product.barcode_qr);
          }, 150);
        });
        break;
    }
  }, [pageState]);

  useEffect(() => {
    getSubSubcategoryAll(
      { filter: `id_sub_category:${getValues("id_sub_category")}` },
      (res) => {
        if (res.status === 200) {
          setState((prevState) => ({
            ...prevState,
            subsubcategories: res.data.data.length > 0 ? res.data.data : [],
          }));
        }
      }
    );
  }, [getValues("id_sub_category")]);

  useEffect(() => {
    if (state.subcategories && state.subcategories.length > 0) {
      setLoading(false);
    }
  }, [state.subcategories]);

  useEffect(() => {
    const seriesCode = brandPrefix + firstPrefix + secondPrefix;
    setValue("series", seriesCode);
  }, [firstPrefix, secondPrefix, brandPrefix]);

  useEffect(() => {
    if (selectedItemCode != "") {
      const timeOut = setTimeout(() => {
        getProductsAll(
          {
            filterAnd: `item_code:${selectedItemCode},is_active:true`,
            perpage: 10,
          },
          ({ data }) => {
            setState({ ...state, products: data.data });
          }
        );
      }, 350);

      return () => clearTimeout(timeOut);
    }
  }, [selectedItemCode]);

  useEffect(() => {
    if (selectedSupplierCode != "" && selectedSupplierCode.length >= 4) {
      const timeOut = setTimeout(() => {
        getSeupplier(selectedSupplierCode, { perpage: 10 }, ({ data }) => {
          setState({ ...state, suppliers: data.data });
        });
      }, 350);

      return () => clearTimeout(timeOut);
    }
  }, [selectedSupplierCode]);

  useEffect(() => {
    setLoading(true);
    if (!userInfo.access?.master_product?.can_update) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "You're not allowed to access that page!",
      }).then(() => navigate("/"));
    }
    $("#launch_date").datetimepicker({
      format: "YYYY-MM-DD",
    });
    $("#thickness").val(0);
  }, []);

  const onSaveFeature = (reqF, totScore, productClass) => {
    if (totScore < reqF.length) {
      toastError("Please complete score feature type!");
      return;
    } else {
      const _feature_type = [...reqF];

      _feature_type.map((item, i) => {
        item.own = true;
      });

      setState((prev) => {
        return {
          ...prev,
          reqFeature: reqF,
          totScoreFeature: totScore,
          feature_type: _feature_type,
          product_class: productClass,
        };
      });
      setTimeout(() => {
        setValue("product_class", productClass);
        $(modalId10).modal("hide");
      }, 150);
    }
  };
  const onCloseModal4 = () => {
    setTimeout(() => {
      $(modalId10).modal("hide");
    }, 150);
  };

  const propsModalProductFeature = {
    sub_sub_category,
    modalId10,
    onCloseModal4,
    reqFeature,
    totScoreFeature,
    onAddFeatureModal,
    onSaveFeature,
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <ModalFormFeature {...propsModalProductFeature} />
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Create Product </h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <NavLink to="/home">Home</NavLink>
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/product">Product</NavLink>
                </li>
                <li className="breadcrumb-item active">Create Product</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      {loading && <Overlay display={loading} />}
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <Overlay display={processing} />
                <form
                  className="form-create-product"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  {!item_code ? (
                    <div
                      className="card-header"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <div className="col-md-8 col-sm-4">
                        <div className="card-title">
                          <i className="fa fa-edit" /> Create Product
                        </div>
                      </div>

                      <div className="col-md-4 col-sm-8">
                        <InputAutoComplete
                          onSelecItem={onSetItemCode}
                          selectedItem={selectedItemCode}
                          label="item_code"
                          value="item_code"
                          items={products}
                          onItemClick={onCopyItemCode}
                          placeholder="Search Item Code to Copy"
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="card-header">
                      <div className="card-title">
                        <i className="fa fa-edit" /> Create Product
                      </div>
                    </div>
                  )}
                  <div className="card-body">
                    <div className="row">
                      <div
                        className="col-md-12"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Sku state={state} onClick={onAddDigit} />

                        <div className="col-md-6">
                          {activeIndex > -1 ? (
                            <div className="card">
                              <div className="card-header">
                                <div className="card-title">
                                  <i className="fa fa-list" /> List
                                </div>
                              </div>
                              <div className="card-body">
                                <div className="form-group">
                                  <label htmlFor="detail_name">Name</label>
                                  <input
                                    name="detail_name"
                                    value={skuHeaders[activeIndex].header_name}
                                    className="form-control"
                                    rows={2}
                                    disabled={true}
                                  />

                                  <label>Code</label>
                                  <select
                                    id="header_code"
                                    className="form-control"
                                    onChange={(e) =>
                                      setSku(
                                        e,
                                        skuHeaders[activeIndex].sku_index
                                      )
                                    }
                                    value={
                                      sku[skuHeaders[activeIndex].sku_index]
                                        ? sku[skuHeaders[activeIndex].sku_index]
                                        : ""
                                    }
                                  >
                                    <option value={""}>Select Code</option>
                                    {skuHeaders[activeIndex].header_type ==
                                    "numeric"
                                      ? skuHeaders[
                                          activeIndex
                                        ].header_value.map((item, i) => (
                                          <option
                                            key={`prefix-` + i}
                                            value={item}
                                          >
                                            {item}
                                          </option>
                                        ))
                                      : skuHeaders[
                                          activeIndex
                                        ].header_value.map((item, i) => (
                                          <option
                                            key={`prefix-` + i}
                                            value={item.detail_code}
                                          >
                                            {item.detail_name}
                                          </option>
                                        ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="card">
                              <div className="card-header">
                                <div className="card-title">
                                  <i className="fa fa-list" /> List
                                </div>
                              </div>
                              <div className="card-body">
                                <div className="form-group">
                                  <label htmlFor="detail_name">Name</label>
                                  <input
                                    name="detail_name"
                                    value=""
                                    className="form-control"
                                    rows={2}
                                    disabled={true}
                                  />

                                  <label>Code</label>
                                  <select
                                    id="header_code"
                                    className="form-control"
                                  >
                                    <option value={""}>Select Code</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="dropdown-divider" />

                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Subcategory Prefix</label>
                          <select
                            id="prefix"
                            className="form-control"
                            {...register("prefix", {
                              required: {
                                value: true,
                                message: "Subcategory prefix is required!",
                              },
                              onChange: setChange,
                            })}
                          >
                            <option value={""}>
                              Select Subcategory Prefix
                            </option>
                            {subprefixs.map((item, i) => (
                              <option
                                key={`subprefix-` + i}
                                value={item.header_code}
                              >
                                {item.header_code}
                              </option>
                            ))}
                          </select>
                          {errors.prefix && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.prefix.message}
                            </span>
                          )}
                        </div>

                        <label>Brand</label>
                        <div className="form-group">
                          <select
                            id="id_brand"
                            className="form-control"
                            {...register("id_brand", {
                              required: {
                                value: true,
                                message: "Brand is required!",
                              },
                              onChange: onBrandChange,
                            })}
                          >
                            <option value={""}>Select Brand</option>
                            {brands.map((item, i) => (
                              <option
                                key={`brand-` + i}
                                value={item.id + "-" + item.prefix}
                              >
                                {item.brand_name}
                              </option>
                            ))}
                          </select>
                          {errors.id_brand && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.id_brand.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label>Segment</label>
                          <fieldset disabled>
                            <select
                              id="id_segment"
                              className="form-control"
                              {...register("id_segment", {
                                required: {
                                  value: true,
                                  message: "Segment is required!",
                                },
                              })}
                            >
                              <option value="">Select Segment</option>
                              {segments.map((item, i) => (
                                <option key={`seg-` + i} value={item.id}>
                                  {item.segment_name}
                                </option>
                              ))}
                            </select>
                          </fieldset>
                          {errors.id_segment && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.id_segment.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label>Category</label>
                          <fieldset disabled>
                            <select
                              id="id_category"
                              className="form-control"
                              {...register("id_category", {
                                required: {
                                  value: true,
                                  message: "Category is required!",
                                },
                              })}
                            >
                              <option value={""}>Select Category</option>
                              {categories.map((item, i) => (
                                <option key={`cat-` + i} value={item.id}>
                                  {item.category_name}
                                </option>
                              ))}
                            </select>
                          </fieldset>
                          {errors.id_category && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.id_category.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label>Subcategory</label>
                          <fieldset disabled>
                            <select
                              id="id_sub_category"
                              className="form-control"
                              {...register("id_sub_category", {
                                required: {
                                  value: true,
                                  message: "Subcategory is required!",
                                },
                              })}
                            >
                              <option value={""}>Select Subcategory</option>
                              {subcategories.map((item, i) => (
                                <option key={`subctg-` + i} value={item.id}>
                                  {item.sub_category_name}
                                </option>
                              ))}
                            </select>
                          </fieldset>
                          {errors.id_sub_category && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.id_sub_category.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label>Sub - Subcategory</label>
                          <fieldset disabled={getValues("prefix") == ""}>
                            <select
                              id="id_sub_sub_category"
                              className="form-control"
                              {...register("id_sub_sub_category", {
                                required: {
                                  value: true,
                                  message: "Sub - Subcategory is required!",
                                },
                                onChange: onSubSubChange,
                              })}
                            >
                              <option value={""}>
                                Select Sub - Subcategory
                              </option>
                              {subsubcategories?.map((item, i) => (
                                <option key={`sub-subctg-` + i} value={item.id}>
                                  {item.sub_sub_category_name}
                                </option>
                              ))}
                            </select>
                          </fieldset>
                          {errors.id_sub_sub_category && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.id_sub_sub_category.message}
                            </span>
                          )}
                        </div>

                        {pseries && (
                          <div className="form-group">
                            <label>Product Series</label>
                            <select
                              id="id_series"
                              className="form-control"
                              {...register("id_series", {
                                required: {
                                  value: true,
                                  message: "Series is required!",
                                },
                                onChange: onSerieshange,
                              })}
                            >
                              <option value={""}>Select Series</option>
                              {pseries?.map((item, i) => (
                                <option key={`series-` + i} value={item.id}>
                                  {item.series_name}
                                </option>
                              ))}
                            </select>
                            {errors.id_series && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.id_series.message}
                              </span>
                            )}
                          </div>
                        )}

                        {iotseries && showIotSeries && (
                          <div className="form-group">
                            <label>IoT Series</label>
                            <select
                              id="code_iot_series"
                              className="form-control"
                              {...register("code_iot_series", {
                                onChange: onIotSerieshange,
                              })}
                            >
                              <option value={""}>Select IoT Series</option>
                              {iotseries?.map((item, i) => (
                                <option
                                  key={`iot-series-` + i}
                                  value={item.series_code}
                                >
                                  {item.series_name}
                                </option>
                              ))}
                            </select>
                            {errors.code_iot_series && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.code_iot_series.message}
                              </span>
                            )}
                          </div>
                        )}

                        <div className="row">
                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="is_active">Active</label>
                              <div>
                                <Controller
                                  name="is_active"
                                  control={control}
                                  render={({ field }) => {
                                    return (
                                      <InputSwitch
                                        {...field}
                                        checked={field.value}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="is_publish_web">
                                Publish Web
                              </label>
                              <div>
                                <Controller
                                  name="is_publish_web"
                                  control={control}
                                  render={({ field }) => {
                                    return (
                                      <InputSwitch
                                        {...field}
                                        checked={field.value}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="is_manage_serial">
                                Manage Serial Number
                              </label>
                              <div>
                                <Controller
                                  name="is_manage_serial"
                                  control={control}
                                  render={({ field }) => {
                                    return (
                                      <InputSwitch
                                        {...field}
                                        checked={field.value}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Color</label>
                          <select
                            id="color"
                            className="form-control"
                            {...register("color", {
                              required: {
                                value: true,
                                message: "Color is required!",
                              },
                              onChange: setColor,
                            })}
                          >
                            <option value="">Select Color</option>
                            {colors.map((item, i) => (
                              <option key={`color-` + i} value={item.code}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                          {errors.color && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.color.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label>Country</label>
                          <select
                            id="country_code"
                            className="form-control"
                            {...register("country_code", {
                              required: {
                                value: true,
                                message: "Country code is required!",
                              },
                              onChange: setCountry,
                            })}
                          >
                            <option value={""}>Select Country</option>
                            {countries.map((item, i) => (
                              <option
                                key={`country-` + i}
                                value={item.country_code}
                              >
                                {item.country_name}
                              </option>
                            ))}
                          </select>
                          {errors.country_code && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.country_code.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label>Certificate</label>
                          <select
                            id="certificate"
                            className="form-control"
                            {...register("certificate", {
                              required: {
                                value: true,
                                message: "Certificate is required!",
                              },
                              onChange: setCert,
                            })}
                          >
                            <option value="">Select Certificate</option>
                            {certs.map((item, i) => (
                              <option key={`cert-` + i} value={item.code}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                          {errors.certificate && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.certificate.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label>Electrical Rating</label>
                          <select
                            id="electrical_rating"
                            className="form-control"
                            {...register("electrical_rating", {
                              required: {
                                value: true,
                                message: "Electrical rating is required!",
                              },
                              onChange: setERating,
                            })}
                          >
                            <option value={""}>Select Electrical Rating</option>
                            {eratings.map((item, i) => (
                              <option key={`erating-` + i} value={item.code}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                          {errors.electrical_rating && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.electrical_rating.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label>Assembly</label>
                          <select
                            id="assembly"
                            className="form-control"
                            {...register("assembly", {
                              required: {
                                value: true,
                                message: "Assembly is required!",
                              },
                              onChange: setAssembly,
                            })}
                          >
                            <option value={""}>Select Assembly</option>
                            {assembles.map((item, i) => (
                              <option
                                key={`assembly-` + i}
                                value={item.code + "-" + item.name}
                              >
                                {item.name}
                              </option>
                            ))}
                          </select>
                          {errors.assembly && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.assembly.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label>Original Item (SKU)</label>
                          <input
                            name="item_code_original"
                            className="form-control"
                            {...register("item_code_original")}
                            placeholder="Original Item Code if SKD"
                          />
                        </div>
                        {/* {JSON.stringify(feature_type)} */}
                        <div className="d-flex justify-content-between">
                          <div className="form-group col-sm-8 mr-3">
                            <label htmlFor="product_class">Product Class</label>
                            <input
                              id="product_class"
                              {...register("product_class")}
                              placeholder=""
                              className="form-control"
                              readOnly={true}
                            />
                            {errors.product_class && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.product_class.message}
                              </span>
                            )}
                          </div>
                          <div className="col-sm-4" style={{ marginTop: 32 }}>
                            <button
                              type="button"
                              className="btn btn-warning mr-2"
                              onClick={() => onAddFeatureModal(reqFeature)}
                              disabled={reqFeature.length == 0}
                            >
                              {" "}
                              {feature_type.length > 0
                                ? "Manage"
                                : "Manage"}{" "}
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Part Change Sequence</label>
                          <select
                            id="part_change_sequence"
                            className="form-control"
                            {...register("part_change_sequence", {
                              required: {
                                value: true,
                                message: "Part Change Sequence is required!",
                              },
                              onChange: setPartSequence,
                            })}
                          >
                            <option value="">
                              Select Part Change Sequence
                            </option>
                            <option value="0">0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                          </select>
                          {errors.part_change_sequence && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.part_change_sequence.message}
                            </span>
                          )}
                        </div>
                        <div className="form-group">
                          <label>Part Change Location</label>
                          <select
                            id="part_change_location"
                            className="form-control"
                            {...register("part_change_location", {
                              required: {
                                value: true,
                                message: "Part Change Location is required!",
                              },
                              onChange: setPartLocation,
                            })}
                          >
                            <option value={""}>
                              Select Part Change Location
                            </option>
                            {pcls.map((item, i) => (
                              <option key={`pcl-` + i} value={item.code}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                          {errors.part_change_location && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.part_change_location.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="unit">Unit</label>
                          <select
                            id="unit"
                            className="form-control"
                            {...register("unit", {
                              required: {
                                value: true,
                                message: "Unit is required!",
                              },
                            })}
                          >
                            <option value={""}>Select Unit</option>
                            <option value={"UNIT"}>UNIT</option>
                          </select>
                          {errors.unit && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.unit.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="series">Series</label>
                          <input
                            id="series"
                            {...register("series")}
                            placeholder="Series"
                            className="form-control"
                            readOnly={true}
                          />
                          {errors.series && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.series.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="scale">Scale</label>
                          <input
                            id="scale"
                            {...register("scale", {
                              required: {
                                value: true,
                                message: "Scale is required!",
                              },
                            })}
                            placeholder="Scale"
                            className="form-control"
                          />
                          {errors.scale && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.scale.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="scale">Barcode EAN-13</label>
                          <div className="text-center">
                            <input
                              id="barcode_sni"
                              {...register("barcode_sni", {
                                required: {
                                  value: true,
                                  message: "Barcode EAN-13 is required!",
                                },
                                onChange: genBarcode,
                              })}
                              placeholder="Barcode EAN-13"
                              className="form-control"
                            />
                            {errors.barcode_sni && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.barcode_sni.message}
                              </span>
                            )}
                            <div
                              className="w-100 scroll mt-2"
                              style={
                                darkMode
                                  ? {
                                      overflow: "auto",
                                      overflowX: "scroll",
                                      height: 70,
                                      background: "#ccc",
                                    }
                                  : {
                                      overflow: "auto",
                                      overflowX: "scroll",
                                      height: 70,
                                    }
                              }
                            >
                              <canvas className="mt-2" id="barcode"></canvas>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="model_name">Model Code</label>
                          <input
                            id="model_code"
                            {...register("model_code")}
                            placeholder="Model Code"
                            className="form-control"
                            readOnly={false}
                          />
                          {errors.model_code && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.model_code.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="item_name">Item Name</label>
                          <input
                            id="item_name"
                            {...register("item_name", {
                              required: {
                                value: true,
                                message: "Item Name is required!",
                              },
                            })}
                            placeholder="Item Name"
                            className="form-control"
                          />
                          {errors.item_name && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.item_name.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label>Group</label>
                          <select
                            id="group_code"
                            className="form-control"
                            {...register("group_code", {
                              required: {
                                value: true,
                                message: "Group Code is required!",
                              },
                            })}
                          >
                            <option value="">Select Group</option>
                            <option value="113">FG - HOME APPLIANCE</option>
                            <option value="121">FG - PROFESSIONAL</option>
                          </select>
                          {errors.group_code && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.group_code.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="cardcode">Supplier Code</label>
                          <InputAutoComplete
                            selectedItem={selectedSupplierCode}
                            label="CardName"
                            value="CardCode"
                            items={suppliers}
                            placeholder="Type min: 4 char of supplier name"
                            onItemClick={onClickSupplier}
                            register={{
                              ...register("cardcode", {
                                required: {
                                  value: true,
                                  message: "Cardcode is required!",
                                },
                                onChange: onSetSupplierCode,
                              }),
                            }}
                          />
                          {errors.cardcode && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.cardcode.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label>Launch Date</label>
                          <div
                            className="input-group date"
                            id="launch_date"
                            data-target-input="nearest"
                          >
                            <input
                              {...register("launch_date")}
                              type="text"
                              className="form-control datetimepicker-input"
                              data-target="#launch_date"
                              data-toggle="datetimepicker"
                            />
                          </div>
                          {errors.launch_date && (
                            <span
                              className="text-danger"
                              style={{ fontSize: 14 }}
                            >
                              {errors.launch_date.message}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <label>Serial Number</label>
                          <div className="text-center">
                            <input
                              id="barcode_qr"
                              {...register("barcode_qr", {
                                required: {
                                  value: false,
                                  message: "Serial Number is required!",
                                },
                                onChange: genQRCode,
                              })}
                              placeholder="Serial Number"
                              className="form-control"
                            />
                            {errors.barcode_qr && (
                              <span
                                className="text-danger"
                                style={{ fontSize: 14 }}
                              >
                                {errors.barcode_qr.message}
                              </span>
                            )}
                            <div
                              className="w-100 mt-2"
                              style={
                                darkMode
                                  ? { height: 140, background: "#ccc" }
                                  : { height: 140 }
                              }
                            >
                              <canvas className="mt-2" id="qrcode"></canvas>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ProductDimension
                      register={register}
                      errors={errors}
                      countDimension={countDimension}
                    />
                  </div>

                  <div className="card-footer">
                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className="d-flex"
                          style={{ justifyContent: "flex-end" }}
                        >
                          <button
                            type="button"
                            className="btn btn-warning mr-3"
                            style={{ width: 150 }}
                            onClick={onBack}
                          >
                            <i className="fa fa-reply" /> Back
                          </button>
                          <button
                            type="submit"
                            className="btn btn-success"
                            style={{ width: 150 }}
                            disabled={
                              !userInfo.access.master_product?.can_create
                            }
                          >
                            <i className="fa fa-save" /> Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*<ModalImageDesc {...propsModalImageDesc} />
      <ModalFormVideo {...propsModalFormVideo} />
      <ModalVideoDesc {...propsModalVideoDesc} />
                          <ModalFormFeature {...propsModalProductFeature} />*/}
    </div>
  );
};

export default ProductMasterPage;
